module.exports = __webpack_public_path__ + "img/Baseline-Suite.68172a8d.jpg";